var render = function render(){var _vm=this,_c=_vm._self._c;return _c('skeleton',{staticClass:"p-3",attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},_vm._l((_vm.itemsCount),function(i){return _c('tb-skeleton',{key:i,staticClass:"mt-2",attrs:{"aspect-ratio":_vm.height}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }